module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notices"
  }, [_c('div', {
    staticClass: "notice addGroups"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "addBox"
  }, [_c('p', [_c('span', [_vm._v("小组名称：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamName),
      expression: "teamName"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请输入小组名称"
    },
    domProps: {
      "value": (_vm.teamName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.teamName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stuContent"
  }, [_c('div', {
    staticClass: "leftContent"
  }, [_c('form', {
    staticClass: "searchStudents",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keywords),
      expression: "keywords",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请输入学生名字"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'clearBtn': !_vm.btnShow
    },
    on: {
      "click": function($event) {
        _vm.clearInput($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'searchBtn': _vm.btnShow
    },
    on: {
      "click": function($event) {
        _vm.search($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "groups"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noStudent),
      expression: "noStudent"
    }],
    staticClass: "noStu"
  }, [_vm._v("您搜索的学生不存在~")]), _vm._v(" "), _vm._l((_vm.selectStudents), function(item, index) {
    return _c('ul', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.title) + "\n                "), _c('em', [_vm._v("(" + _vm._s(item.data.length) + ")")])]), _vm._v(" "), _vm._l((item.data), function(sitem, sIndex) {
      return _c('li', {
        key: sIndex
      }, [_c('span', {
        class: {
          'active': sitem.checked
        },
        on: {
          "click": function($event) {
            _vm.stuToggle(sitem)
          }
        }
      }, [_vm._v(_vm._s(sitem.userName))])])
    })], 2)
  })], 2)]), _vm._v(" "), (_vm.identify == 'addGroup') ? _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "groups"
  }, [_c('ul', [_c('span', [_vm._v("已选学生\n                "), _c('em', [_vm._v("(" + _vm._s(_vm.selCount) + ")")])]), _vm._v(" "), _c('ul', _vm._l((_vm.selectStu), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('em', {
      on: {
        "click": function($event) {
          _vm.deleteAddStu(item, index)
        }
      }
    })])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.identify == 'edit') ? _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "groups"
  }, [_c('ul', [_c('span', [_vm._v("已选学生\n                "), _c('em', [_vm._v("(" + _vm._s(_vm.editStu.length) + ")")])]), _vm._v(" "), _c('ul', _vm._l((_vm.editStu), function(sitem, sIndex) {
    return _c('li', {
      key: sIndex
    }, [_c('span', [_vm._v(_vm._s(sitem.userName))]), _vm._v(" "), _c('em', {
      on: {
        "click": function($event) {
          _vm.deleteStu(sitem, sIndex)
        }
      }
    })])
  }))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "sure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v("取消")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eb596c1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/addGroups.vue
// module id = 1224
// module chunks = 1